const ID_TOKEN_KEY = 'id_token';
const LOCALE = 'locale';
const COOKIE_MAX_AGE_SECONDS = 60 * 60 * 8;

const getCookieValue = (name) => {
  const cookieString = document.cookie || '';
  const cookies = cookieString.split(';');
  for (let i = 0; i < cookies.length; i += 1) {
    const cookie = cookies[i].trim();
    if (cookie.startsWith(`${name}=`)) {
      return decodeURIComponent(cookie.slice(name.length + 1));
    }
  }
  return '';
};

const setCookieValue = (name, value, maxAge = COOKIE_MAX_AGE_SECONDS) => {
  document.cookie = `${name}=${encodeURIComponent(value)}; Path=/; Max-Age=${maxAge}; SameSite=Lax; Secure`;
};

const deleteCookieValue = (name) => {
  document.cookie = `${name}=; Path=/; Max-Age=0; SameSite=Lax; Secure`;
};

export const getToken = () => {
  const token = getCookieValue(ID_TOKEN_KEY) || window.localStorage.getItem(ID_TOKEN_KEY);
  if (token && token !== 'undefined') {
    return token;
  }
  return false;
};

export const saveToken = (token) => {
  setCookieValue(ID_TOKEN_KEY, token);
  window.localStorage.removeItem(ID_TOKEN_KEY);
};

export const destroyToken = () => {
  deleteCookieValue(ID_TOKEN_KEY);
  window.localStorage.removeItem(ID_TOKEN_KEY);
};

export const saveLocale = (locale) => {
  window.localStorage.setItem(LOCALE, locale);
};

export default {
  getToken, saveToken, destroyToken, saveLocale,
};
